import { render, staticRenderFns } from "./Scorm.vue.js?vue&type=template&id=201ffcae!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Scorm.vue?vue&type=template&id=201ffcae"
import script from "./Scorm.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Scorm.vue?vue&type=script&lang=js"
export * from "./Scorm.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Scorm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports